import { Component, OnInit } from '@angular/core';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { MessagesService } from '@core/_services/messages.service';
import { ConfirmationService } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import { dateFormat } from '@core/_utils/date.utils';
import { CommonService } from '@service/common.service';
import { LayoutService } from '../../layout/service/app.layout.service';
import { TranslateService } from '@ngx-translate/core';
import { interval, lastValueFrom, Subscription } from 'rxjs';
import { ApiV6Service } from '@service/apiv6.service';
import { AuthService } from '@auth/auth.service';
import { ItemConfirmComponent } from '../_components/item-confirm/item-confirm.component';
import { storeData, truncString } from '@core/_utils/tools.utils';
import { NotificationService } from '@service/notification.service';
import { DownloadService } from '@service/download.service';

@Component({
    selector: 'page-batch',
    templateUrl: './page-batch.component.html',
    styleUrls: ['./page-batch.component.scss'],
})
export class PageBatchComponent implements OnInit {
    public selectedRows: any[];
    public batchList = [];
    public isDesktop: boolean = false;
    public error = false;
    public errorMessage = '';
    public errorLoaderDialog = false;
    public typeList: SelectItem[];
    public stateList: SelectItem[];
    public listColumns = [];
    public isAdmin = false;
    public execTimer: any;
    public timerSubcribe: Subscription;
    public itemConfirm: ItemConfirmComponent;
    public disabledDel = true;
    public selectedCount = 0;

    // Etat
    // 0 : En attente
    // 1 : En cours
    // 2 : Générée
    // 3 : Echec
    // 4 : Disponible
    // 5 : Expirée

    constructor(
        public menu: MenuServiceInt,
        private api: ApiV6Service,
        protected _messageService: MessagesService,
        public confirmationService: ConfirmationService,
        private commonService: CommonService,
        private main: LayoutService,
        private auth: AuthService,
        private translate: TranslateService,
        private notificationService: NotificationService,
        private downloadService: DownloadService
    ) {
        this.menu.display = true;
        this.isDesktop = this.main.isDesktop();
        this.isAdmin = this.auth.isAdmin();
        this.selectedRows = new Array();
    }

    ngOnInit() {
        this.itemConfirm = new ItemConfirmComponent(this.confirmationService);
        this.timerSubcribe = null;
        this.typeList = [
            { label: this.translate.instant('All'), value: null },
            { label: this.translate.instant('Batch_Type_0'), value: 0 },
            { label: this.translate.instant('Batch_Type_1'), value: 1 },
            { label: this.translate.instant('Batch_Type_2'), value: 2 },
            { label: this.translate.instant('Batch_Type_3'), value: 3 },
            { label: this.translate.instant('Batch_Type_4'), value: 4 },
        ];
        this.stateList = [
            { label: this.translate.instant('All'), value: null },
            { label: this.translate.instant('Batch_State_4'), value: 4 },
            { label: this.translate.instant('Batch_State_1'), value: 1 },
            { label: this.translate.instant('Batch_State_3'), value: 3 },
            { label: this.translate.instant('Batch_State_0'), value: 0 },
            { label: this.translate.instant('Batch_State_2'), value: 2 },
            { label: this.translate.instant('Batch_State_5'), value: 5 },
        ];

        this.listColumns = [{ header: this.translate.instant('Batch_Res'), field: 'batchresult', type: 'String', sort: 'batchresult' }];
        if (this.isAdmin === true) {
            this.listColumns.push({ header: this.translate.instant('User_1'), field: 'login', type: 'String', sort: 'login' });
        }    
        this.listColumns.push({ header: this.translate.instant('Batch_DtDem'), field: 'datedem', type: 'DateTime', sort: 'datedem' });
        this.listColumns.push({ header: this.translate.instant('Batch_DtExec'), field: 'dateexec', type: 'DateTime', sort: 'dateexec' });
        this.listColumns.push({ header: this.translate.instant('Batch_DtExepired'), field: 'dateexpired', type: 'DateTime', sort: 'dateexpired' });
        this.listColumns.push({ header: this.translate.instant('Batch_State'), field: 'batchstate', type: 'integer', sort: null });
        this.listColumns.push({ header: this.translate.instant('Batch_Type'), field: 'batchtype', type: 'integer', sort: null });

        this.findAll(true);
        this.execTimer = interval(10000);
        this.commonService.checkReset();
    }

    public ngOnDestroy() {
        if (this.timerSubcribe !== null) {
            this.timerSubcribe.unsubscribe();
        }
    }

    private timerExecSubcribe() {
        this.timerSubcribe = this.execTimer.subscribe(
            (data) => this.timerExecute(data),
            (error) => this.errorTimer(error)
        );
    }

    private errorTimer(aError) {
        console.log('PageBasketListComponent errorTimer', aError);
    }

    private async timerExecute(aData) {
        let wRes: any = {};
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('getbatchlist', ''));
            this.setFormatedData(wRes);	
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
        }
    }

    private async findAll(aTimer) {
        let wRes: any = {};
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('getbatchdisp', ''));
            this.setFormatedData(wRes);
            if (aTimer === true) {
                this.timerExecSubcribe();
            }
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
            return;
        }
    }

    private setFormatedData(aRes) {
        this.disabledDel = true;
        this.batchList = aRes.data.data.map((item) => {
            item.datedem = item.datedem + '|' + dateFormat(item.datedem, 'dd/MM/yyyy HH:mm:ss');
            if (item.dateexec !== null) {
                item.dateexec = item.dateexec + '|' + dateFormat(item.dateexec, 'dd/MM/yyyy HH:mm:ss');
            }
            if (item.dateexpired !== null) {
                item.dateexpired = item.dateexpired + '|' + dateFormat(item.dateexpired, 'dd/MM/yyyy HH:mm:ss');
            }
            if (item.batchstate === 5) {
                this.disabledDel = false;
            }
            return item;
        });
    }

    public async onDownLoad(event, rowData) {
        let wtype;
        let filename = rowData.batchresult;
        let wRequest = {
            BatchResult: true,
            BatchName: rowData.batchresult,
        };    
        await this.downloadService.downLoadBatch(wRequest, wtype, filename);
    }

    public clickDelExpiredBatch() {
        let wMess = this.translate.instant('Confirm_DelB');
        if (this.selectedRows.length !== 0) {
            wMess = this.translate.instant('Confirm_DelBSel');
        }
        this.itemConfirm.confirmAction(
            'delete',
            wMess,
            () => {
                this.delete();
            }
        );
    }

    public async delete() {
        let wRes: any = {};
        let wList = '';
        let wParams: {};
        this.timerSubcribe.unsubscribe();
        this.selectedRows.forEach((item) => {
            wList = wList + item.id + ',';
        });
        wList = truncString(wList, 1);
        if (this.selectedRows.length !== 0) {
            wParams = {
                expired: false,
                list: wList
            };
        } else {
            wParams = {
                expired: true
            };
        }
        
        try {
            await lastValueFrom(this.api.execUrlAction('deletebatch',wParams));
            this._messageService.addSuccess(this.translate.instant('Update_OK'));
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
        }
        this.selectedRows = [];
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('getactivnotiflist',''));
            this.notificationService.setNotifyList(wRes);
            storeData('notifylist', JSON.stringify(this.notificationService.notifList));
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Failed_NotifList'));
        }
        await this.findAll(true);
    }

    public clickcolck(event) {
        event.stopPropagation();
    }
}
